import { rem } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import React from 'react';
import { RemoveRowButton } from '../RowButtons';

interface RegularValueMappingRowProps {
	onClickRemove: () => void;
}

export default function RegularValueMappingRow({
	onClickRemove,
}: RegularValueMappingRowProps) {
	return (
		<Grid
			item
			xs
			sm={1}
			md={1}
			direction={'row-reverse'}
			style={{
				marginTop: `${rem(8)}`,
				display: 'flex',
				alignContent: 'center',
				verticalAlign: 'middle',
				flexDirection: 'row-reverse',
			}}>
			<RemoveRowButton onClick={onClickRemove} />{' '}
		</Grid>
	);
}
